import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/work-orders')({
  component: RouteComponent,
  staticData: {
    authorization: { permission: { workOrder: ['read'] } },
  },
});

function RouteComponent() {
  return <Outlet />;
}
